/* rd-expiry W2.3 — Frames 2–4 catch-after overlay. CSS copied from the confirmed
   mockup (docs/mockups/client-dashboard-redesign/session-recovery-states.html,
   Frames 2–4: .overlay / .ov-icon[.warm|.ok] / .ov-title / .ov-sub / .ov-when /
   .rc-actions / .rc-btn / .ov-foot). Same token discipline + HONEST swap log as
   ActiveFlowConflictOverlay.module.css / SessionTimedOutOverlay.module.css:
     · var(--font-display)  → var(--client-font-heading), the theme's heading font (EB Garamond by default)
     · var(--r-md|pill)     → literal px (radii are not injected tokens)
   Every colour/glass/accent surface maps to an existing INJECTED foundation token
   (no :root hex block, no new tokens minted). The white button text is a literal. */

/* Full-screen recovery overlay (a scrim over the dimmed page underneath — the
   catch-after surface, NOT a full eviction screen). */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 88;
  background: rgba(var(--bg-page-rgb), 0.92);
  backdrop-filter: blur(9px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 38px calc(var(--tg-safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)));
  animation: ca-fade 0.22s ease;
}
@keyframes ca-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.ovIcon {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-bottom: 22px;
}
.ovIcon svg {
  width: 38px;
  height: 38px;
}
.ovIcon.warm {
  background: rgba(var(--accent-rgb), 0.16);
  border: 1.5px solid rgba(var(--accent-rgb), 0.5);
  color: var(--accent-hot);
  box-shadow: 0 0 38px rgba(var(--accent-rgb), 0.28);
}
.ovIcon.ok {
  background: rgba(var(--ok-rgb), 0.16);
  border: 1.5px solid rgba(var(--ok-rgb), 0.5);
  color: var(--ok);
  box-shadow: 0 0 38px rgba(var(--ok-rgb), 0.3);
}

.ovTitle {
  font-family: var(--font-overlay-title, var(--client-font-heading, 'EB Garamond', Georgia, serif));
  font-weight: 600;
  font-size: 27px;
  color: var(--text-primary);
}
.ovSub {
  margin-top: 12px;
  font-size: 13.5px;
  color: var(--text-secondary);
  line-height: 1.55;
  max-width: 300px;
}
.ovSub b {
  color: var(--text-primary);
  font-weight: 600;
}

/* "When" chip (the existing reservation's date/time). */
.ovWhen {
  margin-top: 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: 9999px;
  background: rgba(var(--accent-rgb), 0.12);
  border: 1px solid rgba(var(--accent-rgb), 0.24);
  font-size: 12.5px;
  color: var(--accent-hot);
  font-weight: 600;
}
.ovWhen svg {
  width: 14px;
  height: 14px;
  stroke-width: 2.2;
}

/* Recovery buttons. */
.rcActions {
  margin-top: 26px;
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.rcBtn {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  border-radius: 14px;
  background: var(--accent-orb);
  color: var(--text-on-accent);
  font-size: 15.5px;
  font-weight: 700;
  letter-spacing: -0.01em;
  box-shadow: var(--glow-amber);
}
.rcBtn svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.4;
}
.rcBtn:disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* Honest footer (Frame 3 "Picking up where you left off…" / inline error copy). */
.ovFoot {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 11.5px;
  color: var(--text-tertiary);
  max-width: 290px;
}
.ovFoot svg {
  width: 13px;
  height: 13px;
  stroke-width: 2;
  flex-shrink: 0;
}

/* Inline retry error copy (recover-hold failed — NOT an eviction; retryable). */
.ovError {
  margin-top: 14px;
  font-size: 12.5px;
  color: var(--accent);
  max-width: 290px;
  line-height: 1.5;
}
